import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ChartOptions, ChartType, ChartDataset } from 'chart.js';
import { ThemeService } from 'ng2-charts';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.css'],
  providers: [ThemeService]
})
export class DoughnutChartComponent implements OnInit, OnChanges {


  @Input()
  chartData: number[];
  @Input()
  doughnutChartLabels: string[];
  @Input()
  chartLabel: string;
  doughnutChartType: ChartType = 'doughnut';
  doughnutChartLegend = true;
  doughnutChartPlugins = [];
  doughnutChartOptions: ChartOptions = {
    responsive: true
  };
  doughnutChartData: ChartDataset[];
  constructor() { }

  ngOnInit() {
    this.doughnutChartData = [
      { data: this.chartData, label: this.chartLabel, backgroundColor:'rgba(70, 190, 170,0.2)', borderColor:"rgba(70,190,170)",borderWidth:1,hoverBackgroundColor:'#5ea599'}
    ];
  }
  ngOnChanges(){
    this.doughnutChartData = [
      { data: this.chartData, label: this.chartLabel}
    ];
  }

}
